import type { SVGProps } from 'react';

import { cn } from '@/lib/utils';

interface PlusIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function PlusIcon({ className, ...props }: PlusIconProps) {
  return (
    <svg
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-5', className)}
      aria-hidden="true"
      {...props}
    >
      <path d="M6.6645 14.1667V8.33225H0.833333C0.373277 8.33225 0.000293034 7.9589 0 7.49892C0 7.03868 0.373096 6.66558 0.833333 6.66558H6.66558V0.833333C6.66558 0.373096 7.03868 -1.56756e-08 7.49892 0C7.9589 0.000293035 8.33225 0.373277 8.33225 0.833333V6.66558H14.1667C14.6269 6.66558 15 7.03868 15 7.49892C14.9997 7.9589 14.6267 8.33225 14.1667 8.33225H8.33116V14.1667C8.33116 14.6269 7.95807 15 7.49783 15C7.03784 14.9997 6.6645 14.6267 6.6645 14.1667Z" fill="currentColor" />
    </svg>
  );
}
